import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar-toggle"
export default class SidebarToggleController extends Controller {
  toggle() {
    this.dispatch("toggle", { target: window })
  }
}
